__turbopack_context__.v({
  "booth": "BoothNumber-module-scss-module__sEV6ta__booth",
  "event": "BoothNumber-module-scss-module__sEV6ta__event",
  "root": "BoothNumber-module-scss-module__sEV6ta__root",
});
